import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap';
import router from './router';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import {faStar} from '@fortawesome/free-solid-svg-icons'
import {faMapLocationDot } from "@fortawesome/free-solid-svg-icons";

library.add(faTrashCan, faStar, faMapLocationDot);


createApp(App).use(router).component('font-awesome-icon', 'FontAwesomeIcon').mount('#app')
